import CTAStrip from "../components/CTAStrip";
import { resolveSite } from "../lib/siteConfig";
import { usePublicData } from "../hooks/usePublicData";
import { useLanguage } from "../context/LanguageContext";
import { pub } from "../lib/pubThemeClasses";
import { Cpu, Ruler, Users, ShieldCheck } from "lucide-react";

export default function About() {
  const { settings } = usePublicData();
  const site = resolveSite(settings);
  const { t } = useLanguage();

  const pillars = [
    { icon: Cpu, title: "about.pillar1.title", body: "about.pillar1.body" },
    { icon: Ruler, title: "about.pillar2.title", body: "about.pillar2.body" },
    { icon: Users, title: "about.pillar3.title", body: "about.pillar3.body" },
    { icon: ShieldCheck, title: "about.pillar4.title", body: "about.pillar4.body" },
  ];

  const vals = [
    { n: "01", tk: "about.v1.title", bk: "about.v1.body" },
    { n: "02", tk: "about.v2.title", bk: "about.v2.body" },
    { n: "03", tk: "about.v3.title", bk: "about.v3.body" },
  ];

  return (
    <div>
      <section className={`relative border-b bg-grain ${pub.borderSubtle}`}>
        <div className="absolute inset-0 grid-lines opacity-50 pointer-events-none" />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4F00] mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[#FF4F00]" /> {t("about.eyebrow")}
            </div>
            <h1 className={`font-display text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight leading-[0.9] ${pub.heroHeading}`}>
              {t("about.hero.line1")}
              <br />
              <span className="text-[#FF4F00]">{t("about.hero.highlight")}</span>
            </h1>
            <p className={`mt-6 text-lg max-w-2xl ${pub.muted}`}>{t("about.intro", { brand: site.brand })}</p>
          </div>
          <div className="lg:col-span-5">
            <div className={`relative border overflow-hidden ${pub.borderSubtle}`}>
              <img
                src="https://images.pexels.com/photos/12698667/pexels-photo-12698667.jpeg"
                alt={t("about.alt.main")}
                className="w-full h-[420px] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[rgba(10,10,11,0.68)] to-transparent" />
            </div>
          </div>
        </div>
      </section>

      <section className={`border-b ${pub.borderSubtle}`}>
        <div className={`mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32 grid grid-cols-1 md:grid-cols-2 overflow-hidden rounded-sm border ${pub.gridHairline} ${pub.borderSubtle}`}>
          {pillars.map((x, i) => (
            <div key={i} className="bg-surface-2 p-8 md:p-10">
              <x.icon className="w-7 h-7 text-[#FF4F00] mb-6" strokeWidth={1.5} />
              <h3 className={`font-display text-2xl md:text-3xl font-black uppercase tracking-tight mb-3 ${pub.heroHeading}`}>{t(x.title)}</h3>
              <p className={`text-sm leading-relaxed max-w-md ${pub.muted}`}>{t(x.body)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={`border-b bg-surface-1 ${pub.borderSubtle}`}>
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4F00] mb-4">{t("about.valuesEyebrow")}</div>
          <h2 className={`font-display text-3xl md:text-5xl font-black uppercase tracking-tight mb-12 max-w-3xl ${pub.heroHeading}`}>{t("about.valuesTitle")}</h2>
          <div className={`grid grid-cols-1 md:grid-cols-3 overflow-hidden rounded-sm border ${pub.gridHairline} ${pub.borderSubtle}`}>
            {vals.map((v) => (
              <div key={v.n} className="bg-surface-2 p-10">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4F00] mb-8">{v.n}</div>
                <h3 className={`font-display text-3xl font-black uppercase tracking-tight mb-3 ${pub.heroHeading}`}>{t(v.tk)}</h3>
                <p className={`text-sm leading-relaxed ${pub.muted}`}>{t(v.bk)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAStrip />
    </div>
  );
}
